export const APP_VERSION = '1791371794118-pjbcot9g6';
